import { cn, Icon } from "@sagot/ui";
import { CHANNEL_ICON, initialsFor } from "./inbox-model";

interface ConversationAvatarProps {
  name: string;
  channel?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE = { sm: "size-7 text-[10px]", md: "", lg: "size-11 text-sm" } as const;

/** Visitor avatar (initials, or a person icon for anonymous visitors) + optional channel badge. */
export function ConversationAvatar({ name, channel, size = "md", className }: ConversationAvatarProps) {
  const initials = initialsFor(name);
  const avatar = (
    <span className={cn("avatar shrink-0", SIZE[size], className)} aria-hidden="true">
      {initials ?? <Icon name="user" className="size-4" />}
    </span>
  );
  if (!channel) return avatar;
  return (
    <span className="relative inline-flex h-fit shrink-0" aria-hidden="true">
      {avatar}
      <span className="absolute -bottom-0.5 -right-0.5 inline-flex size-4 items-center justify-center rounded-pill bg-surface text-primary-ink ring-1 ring-line">
        <Icon name={CHANNEL_ICON[channel] ?? "message-square"} className="size-2.5" />
      </span>
    </span>
  );
}
